import { render, staticRenderFns } from "./node-area-icon.vue?vue&type=template&id=8d505d10&scoped=true"
import script from "./node-area-icon.vue?vue&type=script&lang=js"
export * from "./node-area-icon.vue?vue&type=script&lang=js"
import style0 from "./node-area-icon.vue?vue&type=style&index=0&id=8d505d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d505d10",
  null
  
)

export default component.exports